/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/userprofile.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   User Profile redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Monday, February 12, 2024 - 3:42 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/02/12  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userid: 0,
  companyid: 0,
  error: null,
};

const intFields = ["userid", "companyid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const sessionSlice = createSlice({
  name: "userprofile",
  initialState,
  reducers: {
    updateUserID: (state, action) => updateFieldReducer(state, action, "userid"),
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
  },
});

export const { updateUserID, updateCompanyID } = sessionSlice.actions;

export default sessionSlice.reducer;
